<div style="display: flex; justify-content: center; align-items: center; height: 100vh">
  <h1>Unauthorized!</h1>
</div>
